import { IHotelStaticInfo } from './../core/models/HotelStaticInfo/hotelStaticInfo.interface';
import * as actions from './hotelStaticInfo.actions';
import { createReducer, on, Action } from '@ngrx/store';

const initialState = null;

const _hotelStaticInfoReducer = createReducer(
  initialState,

  on(actions.setHotelStaticInfo, (state, { hotelStaticInfo } ) => {
    return hotelStaticInfo;
  }),
);

export function hotelStaticInfoReducer(state: IHotelStaticInfo, action: Action) {
  return _hotelStaticInfoReducer(state, action);
}
